<form #form="ngForm">
    <app-form-group>
        <div class="col-xs-4 padding0">
            <label for="uf">UF</label>
            <select (change)="onChangeUf()" class="form-control" [(ngModel)]="uf" id="uf" name="uf" appShowErrorMessages [disabled]="isBuscandoCidade || disabled">
              <option [ngValue]="undefined"> Selecione ...</option>
              <option *ngFor="let uf of ufs" [value]="uf.codigo">{{ uf.codigo }}</option>
            </select>
        </div>

        <div [ngSwitch]="isBuscandoCidade" class="col-xs-8">
            <label for="cidade">Cidade</label>
            <select *ngSwitchDefault (change)="onChangeCidade()" [(ngModel)]="cidade" id="cidade" name="cidade" class="form-control" appShowErrorMessages [disabled]="disabled">
              <option [ngValue]="undefined"> Selecione ...</option>
              <option *ngFor="let cidade of cidades" [ngValue]="cidade">{{ cidade }}</option>
            </select>
            <app-loader-default *ngSwitchCase="true"></app-loader-default>
        </div>
    </app-form-group>
</form>
